const LangEgiftCardCheckout = {
	"egiftCardCheckout.to": ["To", "Đến"],
	"egiftCardCheckout.typeYourMessage": [
		"Type your message to the recipient here, up to 255 characters",
		"Nhập tin nhắn bạn muốn gửi tại đây. Tối đa 225 ký tự",
	],
}

export default LangEgiftCardCheckout
